import { useState } from 'react';

export interface Filters {
  searchTerm: string;
  selectedBrands: string[];
  priceRange: [number, number];
  cyod: boolean;
}

export const useProductFilters = () => {
  const [filters, setFilters] = useState<Filters>({
    searchTerm: '',
    selectedBrands: [],
    priceRange: [NaN, NaN],
    cyod: false,
  });

  const setSearchTerm = (value: string) => {
    setFilters((prev) => ({ ...prev, searchTerm: value }));
  };

  const toggleBrand = (brandName: string) => {
    setFilters((prev) => ({
      ...prev,
      selectedBrands: prev.selectedBrands.includes(brandName)
        ? prev.selectedBrands.filter((b) => b !== brandName)
        : [...prev.selectedBrands, brandName],
    }));
  };

  const setPriceRange = (range: [number, number]) => {
    setFilters((prev) => ({ ...prev, priceRange: range }));
  };

  const toggleCyod = () => {
    setFilters((prev) => ({ ...prev, cyod: !prev.cyod }));
  };

  const resetFilters = () => {
    setFilters({
      searchTerm: '',
      selectedBrands: [],
      priceRange: [NaN, NaN],
      cyod: false,
    });
  };

  return {
    filters,
    setSearchTerm,
    toggleBrand,
    setPriceRange,
    toggleCyod,
    resetFilters,
  };
};
